"use client"

import { createContext, useContext, type ReactNode, type CSSProperties } from 'react'

const SheetPresentation = createContext(false)

/** Scope the CRM's overlay presentation without changing the customer portal or website. */
export function BottomSheetPresentation({ children, enabled = true }: { children: ReactNode; enabled?: boolean }) {
  return <SheetPresentation value={enabled}>{children}</SheetPresentation>
}

export function useBottomSheetPresentation() { return useContext(SheetPresentation) }

export function sheetBodyStyle(style?: CSSProperties): CSSProperties | undefined {
  if (!style) return undefined
  return { ...style, position: 'static', inset: 'auto', width: '100%', minWidth: 0, maxWidth: 'none', height: 'auto', maxHeight: 'none', margin: 0, padding: 0, transform: 'none' }
}
